import { useEffect, useState } from "react";
import { useAcademicYearContext } from "../../../context/AacademicYearContext";
import { getFeeDues } from "../services/feeDuesService";
import { FeeDue } from "../types";

export const useFeeDues = (grade: string, section: string, status: string) => {
  const [feeDues, setFeeDues] = useState<FeeDue[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetched, setFetched] = useState(false);

  const fetchFeeDues = async (grade: string, section: string, status: string) => {
    try {
      setLoading(true);
      const data = await getFeeDues(grade, section, status, null);
      setFeeDues(data);
    } catch (err) {
      setError("Failed to fetch fee dues.");
    } finally {
      setLoading(false);
      setFetched(true); // ← mark as fetched
    }
  };

  return { fetched, feeDues, loading, error, fetchFeeDues };
};
